import styled from "styled-components";
import Colors from "@colors";

export const Image = styled.img``;

export const LoadingText = styled.p`
  color: ${Colors.gray};
`;
